import * as tokenActions from './token';
import * as userActions from './user';
import * as dailyVideoActions from './dailyVideo';
import * as adActions from './ad';
import * as magazineActions from './magazine';

// Gather all actions and action types into separate objects that can be imported
// into files from /actions/index file instead of individual action files
const allActions = {
  ...tokenActions,
  ...userActions,
  ...dailyVideoActions,
  ...adActions,
  ...magazineActions
};

export const actionTypes = {};
export const actions = {};

Object.keys(allActions).forEach(key => {
  if (typeof allActions[key] === 'string') {
    actionTypes[key] = allActions[key];
  } else {
    actions[key] = allActions[key];
  }
});



// WEBPACK FOOTER //
// ./src/actions/index.js